import { FC } from 'react';
import { useEntityAffectedSubscription } from '~/hooks';

// Subscription manager wires all the real time notifications and relavant cache updates
export const SubscriptionManager: FC = () => {
  useEntityAffectedSubscription();
  return null;
};
